import React from 'react'
import PropTypes from 'prop-types'
import Select, { Option } from './common/Select'
import { PRESSURE_REPORT_READING_OPTIONS } from '../constants'

export const ALL_PRESSURE_READINGS = PRESSURE_REPORT_READING_OPTIONS.map(
  x => x.value
)

// which pressure monitor readings a report charts. At least one stays
// selected, since a pressure monitor page needs something to chart
const PressureReadingsSelect = ({ value, onChange }) => (
  <Select
    className="w-50-l"
    label="Pressure Readings"
    placeholder="Select pressure readings"
    input={{
      value,
      onChange: x => x.length > 0 && onChange(x),
    }}
    mode="multiple"
  >
    {PRESSURE_REPORT_READING_OPTIONS.map(x => (
      <Option value={x.value} key={x.value}>
        {x.name}
      </Option>
    ))}
  </Select>
)

PressureReadingsSelect.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default PressureReadingsSelect
